import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { subscribeShopify } from '@/service';
import { getPagesPrivacyPolicy } from '@/utils/common';
import moment from 'moment';
import { sendMultiEmarsysEmail } from '@elem/ui/ef-emarsys-email/apis';

export default function G() {
    const { useLang, useRouter, Link, useState, gtm } = useGlobal();
    const { t } = useLang('costsaving');
    const { locale } = useRouter();
    const [msg, setMsg] = useState({ type: '', text: '' });
    const [input, setInput] = useState('');
    const [checked, setChecked] = useState('');

    const validEmail = (_email: string) => {
        if (!/(.+)@(.+){2,}\.(.+){2,}/.test(_email)) {
            setMsg({
                type: 'error',
                text: t('secG_card_tip_format'),
            });
            return false;
        }
        if (!checked) {
            setMsg({
                type: 'error',
                text: t('secG_card_agree_tip'),
            });
            return false;
        }
        return true;
    };

    const handleChangeInput = (e: any) => {
        setInput(e?.target?.value?.trim());
    };

    const handleFocus = () => {
        if (msg?.text && checked) {
            setMsg({ type: '', text: '' });
        }
    };

    const handleCheck = () => {
        setChecked(!checked);
        if (!checked && msg?.text) {
            setMsg({
                type: '',
                text: '',
            });
        }
        if (checked && !msg?.text) {
            setMsg({
                type: 'error',
                text: t('secG_card_agree_tip'),
            });
        }
    };
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const date = moment(systemTime).format('YYYY-MM-DD') as any;
    const submitSubscribe = async (event: any) => {
        event.preventDefault();
        if (!validEmail(input.trim())) {
            return;
        }
        if (['us', 'ca'].includes(locale)) {
            const data = {
                email: input.trim(),
                contactListId: '1487185288',
                fields: [
                    {
                        id: locale === 'us' ? '4423' : '4424',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: false,
                    },
                    {
                        id: '9435',
                        type: 'multiple',
                        value: [10],
                        overwrite: false,
                    },
                    // 订阅日期
                    {
                        id: locale === 'us' ? '9625' : '9626',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ],
            };
            try {
                const res: any = await sendMultiEmarsysEmail(locale, data, { sector_name: t('secG_title'), entry_position: 7 });
                if (res?.code === '0') {
                    setMsg({
                        type: 'success',
                        text: t('secG_card_tip_success'),
                    });
                    setTimeout(() => {
                        setMsg({
                            type: '',
                            text: '',
                        });
                    }, 3000);
                } else {
                    setMsg(res?.message);
                }
            } catch (e) {
                setMsg(e);
            }

            return;
        } else {
            const dataSMS = {
                email: input.trim(),
                contactListId: '891863834',
                fields: [
                    {
                        id: '4434',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '8916',
                        type: 'multiple',
                        value: [16],
                        overwrite: true,
                    },
                ],
            };
            try {
                const res = await subscribeShopify(dataSMS, locale, {
                    sector_name: t('secG_title'),
                    entry_position: '6',
                });
                if (res?.code === '0') {
                    setMsg({
                        type: 'success',
                        text: t('secG_card_tip_success'),
                    });
                    setTimeout(() => {
                        setMsg({
                            type: '',
                            text: '',
                        });
                    }, 3000);
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_submit',
                        button_name: t('secG_card_btn'),
                        status: 'success',
                        tag: 'Agree',
                    });
                } else {
                    setMsg(res?.message);
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_submit',
                        button_name: t('secG_card_btn'),
                        status: 'fail',
                        tag: 'Agree',
                    });
                }
            } catch (e) {
                setMsg(e);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('secG_card_btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        }
    };

    return (
        <div id="cost-saving-G" className={`cost-saving-G cost-saving-box ${css['cost-saving-G']}`}>
            <div className="text-info">
                <h2 className="title">{t('secG_title')}</h2>
                <p className="desc">
                    {t.rich('secG_desc', {
                        a: (a: string) => (
                            <a href={t('secG_desc_link')} target="_blank" className="desc-link" rel="noreferrer">
                                {a}
                            </a>
                        ),
                    })}
                </p>
            </div>
            <div className="card">
                <div className="card-top">
                    <div className="card-img">
                        <EFPicture src="/responsive/picture/common-products/smart_control_kit.png" alt={t('secG_card_title')} />
                    </div>
                    <div className="card-info">
                        <p className="card-title">{t('secG_card_title')}</p>
                        <p className="card-desc">{t('secG_card_desc')}</p>
                    </div>
                </div>
                <p className="card-line"></p>
                <div className="card-bot">
                    <p className="card-text">
                        {t.rich('secG_card_text', {
                            blue: (text: string) => {
                                return <span>{text}</span>;
                            },
                        })}
                    </p>
                    <div className="card-email">
                        <div className="email-box">
                            <input
                                type="text"
                                name="inp_3"
                                className="email"
                                value={input}
                                placeholder={t('secG_card_placeholder')}
                                onChange={handleChangeInput}
                                onFocus={handleFocus}
                            />
                            <button className="signup" onClick={submitSubscribe} aria-label={t('secG_card_btn')}>
                                {t('secG_card_btn')}
                            </button>
                        </div>
                        {msg?.text && (
                            <p className={`msg ${msg?.type}`}>
                                {msg?.type === 'error' && (
                                    <svg className="tip-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <g clipPath="url(#clip0_324_7618)">
                                            <path
                                                d="M6.14966 3L6.46258 7.78185H7.53742L7.85034 3H6.14966ZM6.9932 8.94459C6.72109 8.94459 6.4898 9.0285 6.29932 9.22431C6.09524 9.40613 6 9.64389 6 9.9376C6 10.2173 6.09524 10.4551 6.29932 10.6509C6.4898 10.8467 6.72109 10.9446 6.9932 10.9446C7.26531 10.9446 7.5102 10.8467 7.71429 10.6649C7.90476 10.4691 8 10.2313 8 9.9376C8 9.64389 7.90476 9.40613 7.71429 9.22431C7.52381 9.0285 7.27891 8.94459 6.9932 8.94459Z"
                                                fill="#FA4500"
                                            />
                                            <path
                                                d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
                                                stroke="#FA4500"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_324_7618">
                                                <rect width="14" height="14" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                )}
                                {msg?.text}
                            </p>
                        )}
                        <div className="terms">
                            <input type="checkbox" id="checkbox" className="checkbox" value={checked} onChange={handleCheck} />
                            <span className="terms-text">
                                {t.rich('secG_card_terms', {
                                    t: (text: string) => (
                                        <Link className="terms-link" href={`https://${locale}.ecoflow.com/pages/terms-of-use`}>
                                            {text}
                                        </Link>
                                    ),
                                    p: (text: string) => (
                                        <Link className="terms-link" href={getPagesPrivacyPolicy(locale)}>
                                            {text}
                                        </Link>
                                    ),
                                })}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
